export enum HashKeys {
  approve = '#approve',
  idToken = '#id_token',
  pin = '#pin',
  save = '#save',
  scope = '#scope',
}
